import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Switch,
  TextField,
  Button,
  FormControlLabel,
  Grid,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import SendIcon from '@mui/icons-material/Send';
import LinkIcon from '@mui/icons-material/Link';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import StartIcon from '@mui/icons-material/Start';

const featureIcons = {
  email: <EmailIcon />,
  submit: <SendIcon />,
  redirect: <LinkIcon />,
  confirm: <CheckCircleIcon />,
  pdf: <PictureAsPdfIcon />,
  workFlow: <AccountTreeIcon />,
  lifeCycle: <AccountTreeIcon />,
};

const FormFeaturesPanel = ({
  advanceFeatures = [],
  selectedOptions = {},
  handleAdvanceFeatureSelection,
  updateEmailToSend,
  emailToSend,
  updateRedirectURL,
  redirectURL,
  setIsURLModalOpen,
  showForm,
}) => {
  // 🧩 Local state for rendering features
  const [features, setFeatures] = useState([]);

  // ✅ Initialize state from props when advanceFeatures changes
  useEffect(() => {
    if (advanceFeatures && Array.isArray(advanceFeatures)) {
      setFeatures(advanceFeatures);
    }
  }, [advanceFeatures]);

  return (
    <Box
      sx={{
        padding: 2,
        mt: '5px',
        mb: 1,
        backgroundColor: '#f1f2f5',
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Form Features
          </Typography>
        </Box>
        <Box>{/* Placeholder for future button */}</Box>
      </Box>

      {/* 🧠 Render from local state */}
      <Grid container spacing={2}>
        {features.map((option) => (
          <Grid item xs={12} sm={6} key={option.id}>
            <Box
              sx={{
                borderRadius: '10px',
                backgroundColor: '#ffffff',
                padding: 2,
                boxShadow: '0 1px 6px rgba(0,0,0,0.1)',
                height: '100%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mb: 1,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {featureIcons[option.id] || <CheckCircleIcon />}
                  <Typography variant="subtitle1">{option.name}</Typography>
                </Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={selectedOptions[option.id] || false}
                      onChange={handleAdvanceFeatureSelection}
                      name={option.id}
                      disabled={option.id === 'workFlow'}
                    />
                  }
                  label=""
                />
              </Box>

              {/* Conditional inputs for selected options */}
              {selectedOptions[option.id] && (
                <Box>
                  {option.id === 'email' && (
                    <TextField
                      fullWidth
                      type="email"
                      name={option.id}
                      placeholder={option.placeHolderText}
                      onChange={updateEmailToSend}
                      value={emailToSend}
                      size="small"
                      variant="outlined"
                      sx={{
                        backgroundColor: 'white',
                        '& .MuiInputBase-root': { height: 40 },
                      }}
                    />
                  )}

                  {option.id === 'redirect' && (
                    <TextField
                      fullWidth
                      name={option.id}
                      placeholder={option.placeHolderText}
                      onChange={updateRedirectURL}
                      value={redirectURL}
                      size="small"
                      variant="outlined"
                      sx={{
                        backgroundColor: 'white',
                        '& .MuiInputBase-root': { height: 40 },
                      }}
                    />
                  )}

                  {option.id === 'submit' && (
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => setIsURLModalOpen(true)}
                      sx={{
                        mt: 1,
                        backgroundColor: 'var(--button-color)',
                        textTransform: 'none',
                        ':hover': {
                          backgroundColor: 'var(--button-hover-color)',
                        },
                      }}
                    >
                      Set URL
                    </Button>
                  )}
                </Box>
              )}

              {option.id === 'workFlow' && (
                <Typography
                  variant="caption"
                  sx={{ mt: 1, color: 'gray', fontStyle: 'italic' }}
                >
                  Enterprise Version Only
                </Typography>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FormFeaturesPanel;
